import { useCallback } from 'react';

import { isIn } from '../../utils/array';
import { useTranslations } from '../use-translations';

export function useGetRegionString(): (region: string | null | undefined) => string {
  const t = useTranslations('dictionaries.regions');

  return useCallback(
    (region) => {
      return isIn(region, [
        'africa',
        'arab_states',
        'asia',
        'europe',
        'middle_east',
        'north_america',
        'central_america',
        'latin_america',
      ])
        ? t(region)
        : (region ?? '');
    },
    [t]
  );
}
